import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <h4 class="mb-3 bold text-center">Atena</h4>

    <div class="poem">
      <p class="poem-block mb-3">
        La Diparadizo fermitas al ni por ĉiam’. <br/>
        Atena – en grizaj okuloj glacie briletas flam’. <br/>
        Eternas la saĝo de vi, malgraŭ tempa distanc’, <br/>
        Kaj iĝis olivo la teron penetra lanc’.
      </p>

      <p class="poem-block mb-3">
        Laŭ volo de vi sur ruinoj altiĝis altar’, <br/>
        Aperis la urbo, reganto de mensoj kaj mar’. <br/>
        Jarcentoj trapasos, kaj jam kun alia la nom’ <br/>
        Vi kiel Minerva protektos la filojn de Rom’.
      </p>

      <p class="poem-block mb-3">
        Sed venkos mizero la saĝon, kaj sinkos en fal’ <br/>
        Flugiloj majestaj post glora fiera batal’. <br/>
        Vi flugos meznokte, en morna silenta angor’, <br/>
        Sed fremdas la mondo, kaj portas pereon l’ aŭror’.
      </p>

      <p class="poem-block mb-3">
        La strigo senpaca… Ho, kiel teruras kreiv’ <br/>
        De l’ viv’ senracia, naskanta racion sen viv’! <br/>
        Finiĝos la mondo. Je l’ nomo de akvo kaj flam’, <br/>
        Memor’ mia, restu! Kaj venu al fin’ kun aklam’!
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">Norda vento</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Ni neniam plu ĉe komuna tabl’ <br/>
        Sidos en agrabla agord’,  <br/>
        Ĉar la vento norda penetris tra <br/>
        Frakasita rabie pord’.
      </p>

      <p class="poem-block mb-3">
        Ĝi elrompis vitron el febla krad’, <br/>
        Ĝi forblovis flamon de l’ forn’, <br/>
        Kaj en sia senkompata invad’ <br/>
        Prenas nin, kaj forportas for.
      </p>

      <p class="poem-block mb-3">
        Kaj al ni, amantoj de pac’ kaj kviet’, <br/>
        De libroj, scio kaj sonĝ’ <br/>
        Estas destinite al nokta silent’ <br/>
        Foriri el varma loĝ’.
      </p>

      <p class="poem-block mb-3">
        Ĝuste nin atendas la urba milit’ <br/>
        Kaj odor’ de pulvo kaj polv’, <br/>
        Ĝuste nin sur sonora strata granit’ <br/>
        Militpafos nokta patrol’.   
      </p>

      <p class="poem-block mb-3">
        Vento tranĉas urbon kun akra fort’, <br/>
        Nia vivo spitas al ni, <br/>
        Nia temp’ kiel distordita kord’, <br/>
        Nin atendas lun’ kaj neni’.
      </p>

      <p class="poem-block mb-3">
        Ni ne scias, kio okazos post, <br/>
        La mallum’ ne timigas nin, <br/>
        Ĉar la vento norda frapis al pord’, <br/>
        Ĉar ni lasis eniri ĝin.  
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">Ravenna</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Al la bordo laga peze ruliĝas ond’, <br/>
        Kaj ekstaris el blanka ŝaŭmo vidaĵ’ solena: <br/>
        Temploj, muroj marmoraj – majesta mond’, <br/>
        Kiu sur ĉi-Tero nomiĝas urbo Ravenna.
      </p>

      <p class="poem-block mb-3">
        Temploj, muroj marmoraj – majesta mond’, <br/>
        Protektata por ĉiam per Dia Man’ ĉiopova. <br/>
        Venu, tuŝu, memoru – jen ĉies fond’, <br/>
        Fort’, potenco kaj glor’ de Romo malnova.
      </p>

      <p class="poem-block mb-3">
        Sed ne ĉiuj volas «rekviemi en pac’», <br/>
        Ĉar la dorn’ en polm’, l’ Obeon rompanta Pomo – <br/>
        Tiu urbo sur sep montetoj, virt’ kaj aŭdac’, <br/>
        En kruciĝo de ĉiuj vojoj, eterna Romo.
      </p>
      
      <p class="poem-block mb-3">
        La aer’, per kiu ni spiras, la nokta rev’, <br/>
        La eterna Patrujo, kie ni naskiĝis ĉiuj… <br/>
        Ĉu nin povas indulgi la Papo Sanktega, se <br/>
        Ni memoras, ka antaŭ la Dio regadis Dioj?
      </p>

      <p class="poem-block mb-3">
        Ni aŭskultis Platonon anstataŭ preĝeja ĥor’, <br/>
        Lernis mondhistorion laŭ propra genealogio, <br/>
        Kaj pri niaj versaĵoj vastege aŭdiĝas glor’ – <br/>
        En drinkejoj ĉiuj, alterne kun sakrilegioj.
      </p>

      <p class="poem-block mb-3">
        Sed Ravenna estas beata sub Dia gard’, <br/>
        Kaj de ĉiu muro rigardas la Mastr’ ĉiela… <br/>
        Tamen, pri niaj ludoj de alta hazard’ <br/>
        Vi demandu ĉe korvar’ apud mur’ bordela!
      </p>
      
      <p class="poem-block mb-3">
        Renversiĝis kaliko, kaj flugis soren anĝel’… <br/>
        Sed ja devas iu protekti sanktaĵojn niajn: <br/>
        La eternevivantan, karesan por la orel’ <br/>
        Lingvon, en kiu verkis Katull’ kaj Virgil’ geniaj!
      </p>

      <p class="poem-block mb-3">
        Ni staras lastaj kontraŭ obskur’ kaj Neni’, <br/>
        Kaj inundas la Urbon norda tribar’ abomena… <br/>
        Ĉio, kion atingis, kion meritas ni – <br/>
        Estas ŝanco perei en Rom’, sed ne en Ravenna.
      </p>

      <p class="poem-block mb-3">
        Fumo nigra kaj grasa alflugas al Rejna bord’ <br/>
        El ruinoj de l’ mond’, de kiu restis nur nomo. <br/>
        Sed post tricent jaroj la konkerinta hord’ <br/>
        Iĝos mem eternevivanta kaj glora Romo!
      </p>
    </div>
  `
  )
}

const itemName = {
  esp: 'Elena Mihajlik'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;